import { render, staticRenderFns } from "./trainingresourcesmanager.vue?vue&type=template&id=42da3f16&lang=pug"
import script from "./trainingresourcesmanager.vue?vue&type=script&lang=js"
export * from "./trainingresourcesmanager.vue?vue&type=script&lang=js"
import style0 from "./trainingresourcesmanager.vue?vue&type=style&index=0&id=42da3f16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports